import { useExpenses } from "@/hooks/budget/useExpenses";
import { useCurrencyFormatter } from "@/hooks/budget/useCurrencyFormatter";
import { ExpenseStatsSection } from "../sections/ExpenseStatsSection";
import { ExpenseChartsSection } from "../sections/ExpenseChartsSection";
import { ProfitComparisonSection } from "../sections/ProfitComparisonSection";

export const ExpensesTab = () => {
  const expensesData = useExpenses();
  const { formatCurrency, formatPercentage } = useCurrencyFormatter();

  if (!expensesData) {
    return <div>Chargement...</div>;
  }

  const { dailyData, categoryData, stats } = expensesData;

  return (
    <div className="space-y-6">
      <ExpenseStatsSection
        formatCurrency={formatCurrency}
        formatPercentage={formatPercentage}
        stats={stats}
      />

      <ExpenseChartsSection
        dailyData={dailyData}
        categoryData={categoryData}
        formatCurrency={formatCurrency}
      />

      <ProfitComparisonSection
        formatCurrency={formatCurrency}
      />
    </div>
  );
};